<p-accordion>
        <p-accordionTab header="{{gridSummaryLabel}}">
        <ng-container>
            <ng-template pTemplate="content">
                <div class="table-responsive">
                    <table class="grid-summary-table table table-bordered">
                        <thead>
                            <tr>
                                <th class="grid-summary-header" width="60%">
                                    Name
                                </th>
                                <th class="grid-summary-header" width="20%">
                                    Total Score
                                </th>
                                <th class="grid-summary-header" width="20%">
                                    Maximum Score
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let gridField of gridFields">
                                <tr class="grid-summary-row">
                                    <td class="grid-summary-cell bold">
                                        <label>{{gridField.templateOptions.label}}</label>
                                    </td>
                                    <td class="grid-summary-cell bold">
                                        <label>{{model[gridField.key].totalScore}}</label>
                                    </td>
                                    <td class="grid-summary-cell bold">
                                        <p-inputNumber
                                                       mode="decimal"
                                                       [styleClass]="'w-100'"
                                                       [ngModel]="model[gridField.key].maxScore"
                                                       (onInput)="isTextFieldWithDisplayTotal(gridField) ? setGridMaxScore(gridField, $event.value) : null"
                                                       [useGrouping]="false"
                                                       [minFractionDigits]="0"
                                                       [maxFractionDigits]="0"
                                                       [disabled]="!isTextFieldWithDisplayTotal(gridField) || to.disabled">
                                        </p-inputNumber>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </ng-template>
        </ng-container>
    </p-accordionTab>
</p-accordion>
<div class="clearfix"></div>
<div class="table-responsive">
    <table class="grid-summary-table table table-bordered">
        <thead>
            <tr>
                <th colspan="2" class="grid-summary-header">
                    Overall Summary
                </th>
            </tr>
        </thead>
        <tbody>
            <tr class="grid-summary-row">
                <td class="grid-summary-cell bold">Total Score</td>
                <td class="grid-summary-cell bold">{{overallTotalScore}}</td>
            </tr>
            <tr class="grid-summary-row">
                <td class="grid-summary-cell bold">Maximum Score</td>
                <td class="grid-summary-cell bold">
                    {{overallMaxScore}}
                </td>
            </tr>
            <tr class="grid-summary-row">
                <td class="grid-summary-cell bold">Percentage Rating</td>
                <td class="grid-summary-cell bold">{{ratingPercentage}}%</td>
            </tr>
            <tr class="grid-summary-row">
                <td class="grid-summary-cell bold">Result</td>
                <td class="grid-summary-cell bold">{{ratingLabel}}</td>
            </tr>
            <tr class="grid-summary-row">
                <td class="grid-summary-cell bold">Overall Comments</td>
                <td>
                    <ng-container *ngIf="to.disabled">
                        <label>{{overallComments}}</label>
                    </ng-container>
                    <ng-container *ngIf="!to.disabled">
                        <textarea
                            [disabled]="to.disabled"
                            class="form-control form-a-value w-100"
                            [ngModel]="overallComments"
                            (ngModelChange)="setOverallCommentModel($event)"
                            pInputTextarea
                            autoResize="true"
                            rows="1"
                        ></textarea>
                    </ng-container>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div class="clearfix"></div>
